import { render } from "./cpt-button-option.vue?vue&type=template&id=32205e08"
import script from "./cpt-button-option.vue?vue&type=script&lang=js"
export * from "./cpt-button-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__